<div class="app-splash" >
  <div class="shadow splash-container">
    <div class="background"></div>

    <div class="transparent-div">
      <p><progressbar *ngIf="!hasConnectionError" class="loading-bar"></progressbar></p>
    </div>
    <div class="row menu">
      <div class=" col-md-8">
        <img class="logo" src="assets/images/ecoStruxure_logo_white.png"/>
        <div class="app-name">Power <span class="font-sub">Build - Contractors</span></div>
        <div class="version">Version {{commercialVersion}}</div>
      </div>
      <div *ngIf="hasConnectionError" class="col-md-4 error-message">
        <span class="error-message">Connection error. If the problem persists, please contact the administrator.</span>
        <div><button (click)="relogin()" class="btn btn-retry">Retry</button></div>
      </div>
    </div>
    <div class="splash-footer">
      <div class="footer-message">
        This application is protected by copyright law and international treaties<br/>
        &copy; 2025 Schneider Electric Industries SAS. All Rights Reserved.
      </div>
      <img class="footer-logo" src="assets/images/se_white.png"/>
    </div>
  </div>
</div>
